<template>
  <div class="common-box">
    <div class="design">
      <div class="deisn-slot">
        <div class="design-slot-top">
          <div class="content-left">
            <h3><p>专属考勤开放</p><span>02</span></h3>
            <p>钉钉考勤系统与蓝凌智能OA审批流程打通</p>
            <p>将蓝凌智能OA审批数据写入到钉钉考勤中</p>
            <div class="content-compan">
              <img src="../assets/integrate/icon1.png" alt />
              <span>打通考勤审批流程</span>
            </div>
          </div>
          <div class="content-right">
            <img src="../assets/integrate/inte2.png" alt />
          </div>
        </div>
        <div class="design-slot-bottom">
          <div class="content-left">
            <img src="../assets/integrate/inte3.png" alt />
          </div>
          <div class="content-right">
            <h3><p>专属日程开放</p><span>03</span> </h3>
            <p>DING日程和蓝凌智能OA日程实现同步</p>
            <p>支持增删改查同步</p>
            <div class="content-compan">
              <img src="../assets/integrate/icon1.png" alt />
              <span>同步DING日程</span>
            </div>
            <div class="content-compan">
              <img src="../assets/integrate/icon2.png" alt />
              <span>增删改同步</span>
            </div>
          </div>
        </div>
         <div class="design-slot-top">
              <div class="content-left">
                <h3><p>清爽工作环境</p><span>04</span> </h3>
                <p>为企业提供去运营干扰</p>
                <p>保证企业内部智能工作门户闭环</p>
                <div class="content-compan">
                  <img src="../assets/integrate/Icon3.png" alt />
                  <span>防干扰</span>
                </div>
                 <div class="content-compan">
                  <img src="../assets/integrate/icon4.png" alt />
                  <span>内部空间</span>
                </div>
              </div>
              <div class="content-right">
                <img src="../assets/integrate/inte4.png" alt />
              </div>
            </div>
      </div>
      <!-- <img src="../assets/help/help2.png" alt class="help-circle" /> -->
      <!-- <img src="../assets/help/help1.png" alt class="help-square" /> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {  }
};
</script>

<style lang="less" scoped>
.pt48{
  padding-top: 300px;
}
.design {
  width: 1040px;
  margin: 0 auto;
  color: white;
  position: relative;
  .deisn-slot {
    width: 100%;

    > div {
      display: flex;
      justify-content: space-between;
    }
    .design-slot-top {
      margin: 60px 0;
      .content-left {
        padding-top: 94px;
        padding-left: 80px;
        text-align: left;
        flex: 1;
        > img {
          width: 600px;
        }
        p {
          font-size: 16px;
          color: #666666;
          line-height: 16px;
          line-height: 22px;
        }
        h3 {
          position: relative;
          margin-bottom: 14px;
          font-size: 28px;
          font-weight: normal;
          z-index: 90;
          >p{
            position: relative;
            z-index: 90;
            color: #333333;
            font-size: 28px!important;
          }
          >span {
            position: absolute;
            font-size: 60px;
            text-align: center;
            line-height: 50px;
            left: 0;
            top: -30px;
            color: #ebebeb;
            z-index: 9;
          }
        }
      }
      .content-right {
        flex: 1;
        text-align: left;
        > img {
          width: 520px;
        }
      }
      .content-compan {
        margin-top: 30px;
        font-size: 14px;
        color: #999999;
        display: inline-block;
        margin-right:60px;
        img {
          width: 20px;
          height: 20px;
          vertical-align: text-bottom;
        }
      }
    }
    .design-slot-bottom {
          margin: 60px 0;
      .content-left {
        text-align: left;
        flex: 1;
        > img {
          width: 520px;
        }
      }
      .content-right {
        flex: 1;
        text-align: left;
        padding-left: 123px;
        padding-top: 94px;
        p {
          font-size: 16px;
          color: #666666;
          line-height: 16px;
          line-height: 22px;
        }
        // h3 {
        //   position: relative;
        //   margin-bottom: 14px;
        //   font-size: 28px;
        //   color: #333333;
        //   height:28px;
        //   z-index:8;
        //    span{
        //     position:absolute;
        //     top:0;
        //     left:0;
        //     z-index:10;
        //   }
        //   &::after {
        //     content: "03";
        //     display: inline-block;
        //     position: absolute;
        //     font-size: 60px;
        //     color: #e5e6e6;
        //     line-height: 50px;
        //     left: 0;
        //     top: -30px;
        //   }
        // }
        h3 {
          position: relative;
          margin-bottom: 14px;
          font-size: 28px;
          font-weight: normal;
          z-index: 90;
          >p{
            position: relative;
            z-index: 90;
            color: #333333;
            font-size: 28px!important;  
          }
          >span {
            position: absolute;
            font-size: 60px;
            text-align: center;
            line-height: 50px;
            left: 0;
            top: -30px;
            color: #ebebeb;
            z-index: 9;
          }
        }
      }
      .content-compan {
        margin-top: 30px;
        font-size: 14px;
        color: #999999;
        margin-right:60px;
        display: inline-block;
        img {
          width: 20px;
          height: 20px;
          vertical-align: text-bottom;
        }
      }
    }
    
  }
}
</style>


// WEBPACK FOOTER //
// src/components/integrate.vue